import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";

const RegionDetailsForm = (props) => {
  const [regionName, setRegionName] = useState("");
  const [regionData, setRegionData] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [regionCode, setRegionCode] = useState("");
  const [availableRegionTypes, setAvailableRegionTypes] = useState([]); // Renamed for clarity: holds the list of types
  const [selectedRegionType, setSelectedRegionType] = useState("");

  const { sendRequest: poststationDetails } = useHttp();

  const { sendRequest: getRegionData } = useHttp();

  const { sendRequest: getRegionTypes } = useHttp();

  useEffect(() => {
    getRegionTypes(
      {
        url: `/api/regionTypes/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        const filteredRegionTypes = data.filter(
          (type) => type === "Procurement" || type === "Sales"
        );
        setAvailableRegionTypes(filteredRegionTypes);
      }
    );
  }, []);

  const FillDetail = () => {
    getRegionData(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setRegionData(res);
          //  console.log(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getRegionData]);

  const submitHandler = (e) => {
    e.preventDefault();

    if (!props.update) {
      const isExistingRegion = regionData.some(
        (region) => region.regionName === regionName
      );

      const isExistingCode = regionData.some(
        (region) => region.regionCode === regionCode
      );

      if (isExistingRegion) {
        toast.error("Region name already exists");
        return;
      }
      if (isExistingCode) {
        toast.error("Region code already exists");
        return;
      }
    }

    const data = {
      regionId: regionId,
      regionName: regionName,
      regionCode: regionCode,
      regionType: selectedRegionType,

      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

    console.log("data", data);

    if (props.update) {
      data["regionId"] = props.update.regionId;
    }

    poststationDetails(
      {
        url: "/api/region/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`region Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    console.log(props.update);
    if (props.update) {
      setRegionName(props.update.regionName);
      setRegionId(props.update.regionId);
      setRegionCode(props.update.regionCode);
      setSelectedRegionType(props.update.regionType);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Region Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Region Type</label>
                        <select
                          id="regionTypeSelect" // Changed ID to be more specific
                          className="form-control"
                          required
                          value={selectedRegionType} // Bind to the state variable for the selected type
                          onChange={(e) => {
                            setSelectedRegionType(e.target.value); // Update the selected type state
                          }}
                        >
                          <option value="">Select</option> {/* Added an empty value option */}
                          {availableRegionTypes &&
                            availableRegionTypes.map((type) => (
                              <option key={type} value={type}>
                                {type}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Region Name</label>
                        <input
                          type={"text"}
                          id={"regionName"}
                          required
                          className="form-control"
                          //   readOnly={props.update}
                          value={regionName}
                          onChange={(e) => {
                            setRegionName(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Region Code </label>
                        <input
                          type={"text"}
                          id={"regionCode"}
                          required
                          className="form-control"
                          value={regionCode}
                          //   readOnly={props.update}
                          onChange={(e) => {
                            setRegionCode(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default RegionDetailsForm;
